<template>
  <v-card class="settings-card-primary cost-per-record-form pa-0">
    <div class="d-flex w-100 align-baseline pa-7">
      <v-card-title style="font-weight: bold" class="pa-0">Cyber Security Assessment History</v-card-title>
      <v-spacer></v-spacer>
      <v-btn class="btn-gradient white--text ma-0" to="/settings/cyber-security-assessment/edit/new">Add</v-btn>
    </div>
    <v-data-table
        :headers="headers"
        :items="cyberSecurityAssessments"
        :server-items-length="cyberSecurityAssessments.length"
        :options.sync="options"
        item-key="entity_id"
        class="light-table"
        hide-default-footer
        disable-filtering
        disable-pagination
        disable-sort
        :loading="cyberSecurityAssessmentsLoading"
        loading-text="Loading... Please wait"
    >
      <template v-slot:body="{ items }">
        <tbody>
        <tr v-for="item in items" :key="item.entity_id">
          <!-- <td>
          <v-btn icon @click.stop="$router.push('/collectoreditor/' + item.entity_id)">
            <v-icon class="muted--white">edit</v-icon>
          </v-btn>
        </td> -->
          <td>{{ item.industry }}</td>
          <td>{{ getOverallScoringMethod(item) }}</td>
          <td>{{ getOverallCyberStrengthScore(item) }}</td>
          <td>{{ getOverallCyberWeaknessScore(item) }}</td>
          <td>{{ item.date }}</td>
          <td>
            <div class="d-flex justify-space-between">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    icon
                    class="white-bg"
                    dark
                    v-on="on"
                  >
                    <v-icon color="#2E2B3F">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list class="api-key-edit min">
                  <v-list-item :to="'/settings/cyber-security-assessment/edit/' + item.entity_id">
                    <v-icon>mdi-eye</v-icon>
                  </v-list-item>
                  <v-list-item :to="'/settings/cyber-security-assessment/edit/' + item.entity_id">
                    <v-icon>mdi-square-edit-outline</v-icon>
                  </v-list-item>
                  <v-list-item @click.stop="deleteCyberSecurityAssessment(item.entity_id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

const overallScoringMethods = [
  {
    value: 'score_based', title: 'Score Based'
  },
  {
    value: 'percentage_based', title: 'Percentage Based'
  }
]
export default {
  name: 'CyberSecurityAssessment',
  computed: {
    ...mapGetters(['cyberSecurityAssessments', 'cyberSecurityAssessmentsLoading'])
  },
  data () {
    return {
      headers: [
        {
          text: 'Industry'
        },
        {
          text: 'Assessment Method'
        },
        {
          text: 'Cyber Security Strength'
        },
        {
          text: 'Cyber Security Weakness'
        },
        {
          text: 'Date of Assessment',
          value: ''
        },
        {
          text: ''
        }
      ],
      options: {
        sortable: false
      }
    }
  },

  created () {
  },

  methods: {
    getOverallScoringMethod (item) {
      const method = overallScoringMethods.find(method => method.value === item.overall_scoring_method)
      return method ? method.title : ''
    },
    getOverallCyberStrengthScore (item) {
      if (item.overall_scoring_method === 'score_based') {
        return item.overall_cyber_strength_score
      } else {
        return Math.round(item.overall_cyber_strength_score * 100) + '%'
      }
    },
    getOverallCyberWeaknessScore (item) {
      if (item.overall_scoring_method === 'score_based') {
        return item.overall_cyber_weakness_score
      } else {
        return Math.round(item.overall_cyber_weakness_score * 100) + '%'
      }
    },

    deleteCyberSecurityAssessment (id) {
      this.$store.dispatch('deleteCyberSecurityAssessment', id)
    }
  }
}
</script>
